import { compose, get } from 'lodash/fp';
import { flow } from 'fp-ts/function';
import { createAsyncMetaSelectors } from '@mews/framework';
import { over } from '@mews/fp';
import { ApplicationState } from '@mews-commander/types';
import { AccountingConfiguration } from '@mews-commander/data-access';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getAccountingConfigurationData } from '@mews-commander/legacy-entities/src/ducks/accountingConfigurations';
import { moduleSelector } from '../module';
import { SUBMODULE_NAME_CORE } from '../constants';

const coreSelector = flow(moduleSelector, (state) => state[SUBMODULE_NAME_CORE]);

const metaSelector = flow(coreSelector, (state) => state.meta);
export const [isFetching, hasFailed] = createAsyncMetaSelectors(metaSelector);

export const getEmbeddedToken = compose(get('embeddedToken'), coreSelector);
export const getGroupId = compose(get('groupId'), coreSelector);
export const getReportId = compose(get('reportId'), coreSelector);
export const getDatasetId = compose(get('datasetId'), coreSelector);
export const getAnalyticsType = compose(get('analyticsType'), coreSelector);
export const isDataIntegrityConfirmed = compose(get('dataIntegrityConfirmed'), coreSelector);
export const isFirstRender = flow(coreSelector, get('firstRender'));
export const getEventTimer = flow(coreSelector, get('runningEventTimer'));

export const getEmbedUrl = compose(
    ([reportId, groupId]) => `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupId}`,
    over([getReportId, getGroupId])
);

export const showReceivableTrackingDisabledWarning = (state: ApplicationState) => {
    const enterpriseId = getCurrentEnterpriseId();
    const accountingConfiguration: AccountingConfiguration | undefined = getAccountingConfigurationData(state, {
        enterpriseId,
    });
    return accountingConfiguration?.options.receivableTrackingEnabled === false;
};
